import { render, staticRenderFns } from "./BlanketVOBDetailPlan.vue?vue&type=template&id=19198ab7&scoped=true"
import script from "./BlanketVOBDetailPlan.vue?vue&type=script&lang=js"
export * from "./BlanketVOBDetailPlan.vue?vue&type=script&lang=js"
import style0 from "./BlanketVOBDetailPlan.vue?vue&type=style&index=0&id=19198ab7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19198ab7",
  null
  
)

export default component.exports